"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _UserSelectionCss = _interopRequireDefault(require("./UserSelection.css.js"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _bluekeelControllers = require("@bit/bluekeel.controllers.helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchInput = function SearchInput(_ref) {
  var value = _ref.value,
      handleChange = _ref.handleChange,
      name = _ref.name;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: _UserSelectionCss.default.inputContainer
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    id: "".concat(name, "-input-id"),
    label: name,
    variant: "outlined",
    InputProps: {
      autoFocus: false,
      onChange: handleChange,
      value: (0, _bluekeelControllers.capitalizeValue)(value)
    },
    inputProps: {
      'aria-label': 'search-query-input'
    },
    fullWidth: true,
    style: _UserSelectionCss.default.input
  }));
};

var _default = SearchInput;
exports.default = _default;

//# sourceMappingURL=SearchInput.jsx.map